import React from 'react';
import { Animated, StyleSheet, View, Pressable, Easing, } from 'react-native';
import { FontInfo } from '../~Utilities/Constants';

const DEFAULT_WIDTH   = 350;
const DEFAULT_OPACITY = 0.4;

const AnimatedPressable = Animated.createAnimatedComponent(Pressable);

interface IProps 
  {
  children: React.ReactNode;
  }

/*   ====================================================================   */

export default class Popup extends React.Component<IProps>
 {
   Show()
   {
    this.setState({visible:true,
                   });

    this.state.AnimLeft.setValue(-DEFAULT_WIDTH);

    this.SlideIn();
   }

  /*   -------------------------------------------------------------------   */

    Hide()
    {
    this.SlideOut();
    }

  /*   -------------------------------------------------------------------   */

    HideNoAnimation()
    {
    if (this.state.visible == true)
      this.setState({visible:false});
    }

    /*   -----------------------------------------------------------------   */

    Toggle()
    {
    if (this.state.visible == true)
      this.Hide();
    else
      this.Show();
    }

  /*   -------------------------------------------------------------------   */

    state = {visible:null, 
             AnimLeft: new Animated.Value(-DEFAULT_WIDTH), 
             AnimOp: new Animated.Value(0)};

  /*   -------------------------------------------------------------------   */

  constructor(props)
  {
  super(props);

  this.state      = {visible:null, 
                      AnimLeft:new Animated.Value(-DEFAULT_WIDTH),
                      AnimOp: new Animated.Value(0)};

  this.Show            = this.Show.bind(this);
  this.Hide            = this.Hide.bind(this);
  this.HideNoAnimation = this.HideNoAnimation.bind(this);
  }

/*   -------------------------------------------------------------------   */

  componentDidMount() 
  {
  }

  componentWillUnmount() 
  {
  }

  /*   -------------------------------------------------------------------   */

   SlideIn = () => {
    // Will change fadeAnim value to 1 in 5 seconds
    Animated.timing(this.state.AnimLeft, {
      toValue: 0,
      duration: 200,
      easing: Easing.elastic(1), //Easing.cubic(1),//.bounce(1), //.elastic(2), // Springy
      useNativeDriver:true
    }).start();

    Animated.timing(this.state.AnimOp, {
      toValue: DEFAULT_OPACITY,
      duration: 200,
      //easing: Easing.elastic(1), // Springy
      useNativeDriver:true
    }).start();    
  };

  /*   -------------------------------------------------------------------   */

  SlideOut = () => {
    // Will change fadeAnim value to 0 in 3 seconds
    Animated.timing(this.state.AnimLeft, {
      toValue: -(DEFAULT_WIDTH - 25),
      duration: 100,
      //easing: Easing.back(1), //Easing.cubic(1),//.bounce(1), //.elastic(2), // Springy
      useNativeDriver:true
    }).start(()=>{ this.setState({visible:false}) });

    Animated.timing(this.state.AnimOp, {
      toValue: 0,
      duration: 100,
      //easing: Easing.elastic(1), // Springy
      useNativeDriver:true
    }).start();        
  };

  /*   -------------------------------------------------------------------   */

  render() 
   {
    if (!this.state.visible) 
    return(null);
    else  
    return(
        <View style={{alignItems:'center', justifyContent:'center', position: 'absolute', left:0, right:0, zIndex: 200, backgroundColor: 'transparent', top:0, bottom:0}}>
        <AnimatedPressable
        onPress={this.Hide}
        style={this.state.visible == false? {display:'none'} : {position: 'absolute', left:0, right:0, zIndex: 200, backgroundColor: 'black', opacity: this.state.AnimOp, top:0, bottom:0}}
        >
        </AnimatedPressable>

        <Animated.View 
        
        style={
            {
            //position:'absolute',
            //alignSelf:'center',
            
            zIndex:1201,

            minWidth:DEFAULT_WIDTH - 25, 
            minHeight:200,

            flexDirection:'column', 
            justifyContent:'center',
            backgroundColor:FontInfo.sBackgroundTp, 
                        
            //marginLeft:this.state.AnimLeft, 
            transform: [{translateX: this.state.AnimLeft}],

            borderRadius:20,
            }}>

        {this.props.children}

        </Animated.View>

        

        </View>
        ); 

   }
}

/*   =====================================================================   */

const styles = StyleSheet.create({

    container_sort_cover: {
      backgroundColor: 'transparent',
      alignSelf:'center',
      width:200,
    },
  
    container_sort: {
      backgroundColor: 'transparent',
      alignSelf:'center',
    },
  
    tile_sort: {
      backgroundColor:'transparent',
      width: '100%',
      height: '100%',
    },
});